import { composeWithDevTools } from '@redux-devtools/extension';
import { applyMiddleware, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import * as storage from 'redux-storage';
import createEngine from 'redux-storage-engine-localstorage';
import thunkMiddleware from 'redux-thunk';
// blacklist this actions from triggering a state save
import { BUYING, SELECTING_CATEGORY, SELECTING_SECTION, SET_CONFIG } from './actions';
import reducer from './reducers';

/**
 * Redux store creation
 *
 * @author John Noel <john.noel@rckt.co.uk>
 * @package KingsCamp
 */
const storeId = `${process.env.MIX_REACT_APP_NAME}-${process.env.MIX_REACT_APP_VERSION}`;
const engineReducer = storage.reducer(reducer);
const engine = createEngine(storeId);
const engineMiddleware = storage.createMiddleware(engine, [SELECTING_SECTION, SELECTING_CATEGORY, BUYING]);
const engineLoader = storage.createLoader(engine);

let enhancer = applyMiddleware(thunkMiddleware, engineMiddleware);

if (process.env.NODE_ENV !== 'production') {
    const loggerMiddleware = createLogger({ collapsed: true });

    enhancer = composeWithDevTools(applyMiddleware(thunkMiddleware, engineMiddleware, loggerMiddleware));
}

export default function configureStore(initialState) {
    const cachedStore = typeof window !== 'undefined' ? !!localStorage.getItem(storeId) : false;
    const store = cachedStore
        ? createStore(engineReducer, JSON.parse(localStorage.getItem(storeId)), enhancer)
        : createStore(engineReducer, initialState, enhancer);

    engineLoader(store);

    return store;
}
